import React, {useEffect, useMemo} from 'react';
import {View} from 'react-native';
import {useStyles as useStylesHook} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text/index.web';
import {LinkAccountCard} from './linkedAccountCard';
import {useAccountLinker} from '../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';

import {useAppDispatch} from '../../../../../redux';
import {addNotification} from '../../../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../../../shared/components/snackbar/model';

export default () => {
  const styles = useStylesHook(({theme}) => {
    return {
      container: {
        minWidth: '100%',
        position: 'absolute',
      },
      h2: {
        ...theme.fonts.h2,
      },
      h3: {
        ...theme.fonts.h3,
      },
      accessGranted: {
        ...theme.fonts.h3,
      },
      accessGrantedTo: {
        marginTop: 15,
        ...theme.fonts.h3,
      },
      h4: {
        ...theme.fonts.h4,
      },
      button: {
        marginLeft: 0,
        width: 203,
      },
    };
  });

  const {linkedAccounts, getActivationStatus} = useAccountLinker();
  const dispatch = useAppDispatch();

  const parentsLinks = useMemo(
    () => linkedAccounts.filter((accountInfo) => accountInfo.isCardHolderParent === true),
    [linkedAccounts],
  );
  const childrenLinks = useMemo(
    () => linkedAccounts.filter((accountInfo) => accountInfo.isCardHolderParent === false),
    [linkedAccounts],
  );

  useEffect(() => {
    const wait = setTimeout(() => {
      const isNeedActivation = getActivationStatus && getActivationStatus();
      if (isNeedActivation)
        dispatch(
          addNotification({
            message: 'Активируйте карты связанных аккаунтов',
            type: SnackbarNotificationType.Warning,
          }),
        );
    }, 1500);
    return () => clearTimeout(wait);
  }, [linkedAccounts]);

  const presenceLinkingAccountRequests = useMemo(
    () => (linkedAccounts.length === 0 ? 'noLinkingAccountRequest' : 'linkingAccountRequestsPresent'),
    [linkedAccounts],
  );
  const displayStatusLinkingAccountRequests = {
    noLinkingAccountRequest: <></>,
    linkingAccountRequestsPresent: (
      <>
        {parentsLinks.length !== 0 ? (
          <>
            <Text testID='profile-label-id' style={styles.accessGranted}>
              Доступ предоставлен
            </Text>
            {parentsLinks.map((accountInfo, i) => {
              return (
                <LinkAccountCard
                  key={`${i}${accountInfo.id}`}
                  cardNo={accountInfo.cardNumber ? accountInfo.cardNumber : 'карта ЕСК не предоставлена'}
                  status={accountInfo.status}
                  linkedAccountHolderFullName={accountInfo.counterpartyFullName}
                  id={accountInfo.id}
                  isParent={accountInfo.isCardHolderParent}
                />
              );
            })}
          </>
        ) : null}
        {childrenLinks.length !== 0 ? (
          <>
            <Text testID='profile-label-id' style={styles.accessGrantedTo}>
              Доступ предоставили
            </Text>
            {childrenLinks.map((accountInfo, i) => {
              return (
                <LinkAccountCard
                  key={`${i}${accountInfo.id}`}
                  cardNo={accountInfo.cardNumber}
                  status={accountInfo.status}
                  linkedAccountHolderFullName={accountInfo.counterpartyFullName}
                  id={accountInfo.id}
                  isParent={accountInfo.isCardHolderParent}
                />
              );
            })}
          </>
        ) : null}
      </>
    ),
  };
  return (
    <View style={{paddingLeft: 0, marginTop: 30}}>
      {displayStatusLinkingAccountRequests[presenceLinkingAccountRequests]}
    </View>
  );
};
